'use client'
import styles from './page.module.scss'
import { useState } from 'react';  
import { motion } from 'framer-motion';
import useMousePosition from '../components/utils/useMousePosition'

export default function Home() {

  const [isHovered, ] = useState(false);
  const { x, y } = useMousePosition();
  const size = isHovered ? 200 : 40;

  return (
    <main className={styles.main}>
      <motion.div 
        className={styles.mask}
        animate={{
          WebkitMaskPosition: `${x - (size/2)}px ${y - (size/2)}px`,
          WebkitMaskSize: `${size}px`,
        }}
        transition={{ type: "tween", ease: "backOut", duration:0.5}}
      >
        

      
      </motion.div>

      <div className={styles.body}>
        <p className='  lg:text-[14vh] xl:text-[17.8vh]  2xl:text-[18.6vh] sm:text-[6vh] lg:mt-24 lg:-ml-8 text-[70px] text-white'>MD SHAKIL HOSSAIN <span className="text-[455ce9]">    </span> 

           </p>
      </div>

    </main>
  )
}
